module.exports = __webpack_public_path__ + "img/header-memoireRingsCheap@2x.0d8d37b.jpg";